<template>
  <transition name="fade">
    <b-card no-body class="w-100">
      <div slot="header">
        {{ title }}
      </div>

      <b-card-body>
        <div class="chart-container">
          <div class="section-selector">
            <span class="label">By</span>
            <b-form-select
              @input="value => { topSectionField.value = value }"
              :options="topSectionField.choices"
              v-model="topSectionField.value"
              class="select"
              size="sm" />
          </div>

          <bar-chart :items="topSection" />
        </div>

        <div class="chart-container">
          <div class="section-selector">
            <span class="label">By</span>
            <b-form-select
              @input="value => { bottomSectionField.value = value }"
              :options="bottomSectionField.choices"
              v-model="bottomSectionField.value"
              class="select"
              size="sm" />
          </div>

          <bar-chart :items="bottomSection" />
        </div>

      </b-card-body>
    </b-card>
  </transition>
</template>

<script>
  import getNested from 'lodash-es/get'
  import BarChart from '../widgets/BarChart'
  import { titleCase } from '@/shared/string-utils'

  export default {
    name: 'directions-stat',

    components: {
      BarChart,
    },

    props: {
      title: {
        type: String,
        default: () => 'No title',
      },

      sectionSelector: {
        type: Boolean,
        default: false,
      },

      topSectionName: {
        type: String,
        default: 'unknown-top-section',
      },

      bottomSectionName: {
        type: String,
        default: 'unknown-bottom-section',
      },

      stats: {
        type: Object,
        default: () => ({}),
      },
    },

    data() {
      return {
        topSectionField: {
          value: null,
          choices: [],
        },

        bottomSectionField: {
          value: null,
          choices: [],
        },

        defaultSectionStats: [],
      };
    },

    mounted() {
      this.topSectionField.choices = this.getSectionFieldChoices();
      this.topSectionField.value = this.topSectionName;

      this.bottomSectionField.choices = this.getSectionFieldChoices();
      this.bottomSectionField.value = this.bottomSectionName;
    },

    methods: {
      getSectionFieldChoices() {
        return Object.keys(this.stats).map(
          sectionName => ({
            text: titleCase(sectionName),
            value: sectionName
          })
        );
      },
    },

    computed: {
      topSection() {
        return getNested(this.stats, this.topSectionField.value, this.defaultSectionStats);
      },

      bottomSection() {
        return getNested(this.stats, this.bottomSectionField.value, this.defaultSectionStats);
      },
    },
  }
</script>

<style scoped lang="scss">
  .chart-container {
    margin-bottom: 20px;
    height: 50%;

    .section-selector {
      margin-bottom: 0.75rem;
      display: flex;
      align-items: center;

      .label {
        padding-right: 0.5rem;
      }

      .select {
        max-width: 100px;
      }
    }
  }

  .chart-container:not(:last-child) {
    border-bottom: 1px solid gray;
  }
</style>
